import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { UserService } from 'src/app/services/user/user.service';
import * as alertifyjs from 'alertifyjs';
import { IdentGuard } from '../../guards/ident.guard';
import { error } from 'console';

@Component({
  selector: 'app-person-plans',
  templateUrl: './person-plans.component.html',
  styleUrls: ['./person-plans.component.css'],
  providers: [DatePipe],
})
export class ClientPlansComponent implements OnInit {
  getSection_transaction_by_person() {
    throw new Error('Method not implemented.');
  }
  getAnalysis(person: any) {
    throw new Error('Method not implemented.');
  }
  invoicesPending() {
    throw new Error('Method not implemented.');
  }
  plans: any[] = [];
  customerPlans_obj: any = {};

  plans_loading: any = true;
  status_plans: any = true;
  isCustomerPlans_obj: any = true;

  plans_active: any;
  plans_inactive: any;
  queryParams: any;
  loading = true;
  person: any;
  selectedPlan: any | null = null;
  publicPlans: any;
  morePublicPlans: any;
  showAllPublicPlansToggle: any;
  privatePlans: any[] = [];
  selectedPrivatePlan: any;
  code: any;
  id: any;
  by_default: any;
  id_ejecutive: any;
  personDynamicCodes: string[] = []; // Nueva propiedad para códigos dinámicos

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    private offcanvasService: NgbOffcanvas,
    public _auth: AuthService
  ) {}

  ngOnInit(): void {

    this.activatedRoute.params.subscribe((params) => {
      this.queryParams = params;
      if (this.queryParams?.code) {
        this.getPerson();
        this.getCustomerPlans(this.queryParams.code);
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/console/person/profile', this.queryParams?.code]);
  }

  getContact(item: any) {
    if (!(item?.constacts?.length > 0)) return '';

    return `${item?.constacts[0]?.contact}`;
  }

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 1) || !item?.constacts[1])
      return "";

    return `${item?.constacts[1]?.contact}`;
  }

  pocisionBottom(template: any): void {
    this.offcanvasService.open(template, { position: 'bottom' });
  }

  getPerson = async () => {
    this.loading = true;

    try {
      const resp = await this._user.getPersonbyCode({
        code: this.queryParams.code,
      });

      this.person = resp.resp;
      this.code = this.queryParams.code;

      // Obtener códigos dinámicos directamente del cliente
      this.personDynamicCodes = this.person?.person?.params?.dinamic_code || [];

      console.log('Person data:', this.person);
      console.log('Dynamic codes extracted:', this.personDynamicCodes);

      // Por si acaso
      this.id = this.person._id;
      this.getPlans();
      this.loadPrivatePlans();


    } catch (error) {
      console.log(error);
    }

    this.loading = false;
  };

  getIdentity(item: any) {
    if (!(item?.identitys?.length > 0)) return '';

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;
  }

  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  getCustomerPlans = async (code: string) => {

    try {
      const response = await this._user.getCustomerPlans(code);
      this.customerPlans_obj = {}



      for(let item of response){
        this.customerPlans_obj[item.plan] = item;

      }

      if (response?.length > 0){
        this.isCustomerPlans_obj = true;

      }else{
        this.isCustomerPlans_obj = false;

      }

    } catch (err) {
      console.error('Failed to load customer plans:', err);
    } finally {
    }
  };

  getPlans = async (plans_loading = true) => {
    try {
      this.plans_loading = plans_loading;

      let publicPlans = await this._user.getplans({"person_code":this.person?.person?.code});
      this.publicPlans = publicPlans?.res?.filter(
        (item: any) => item.visibility === 'PUBLIC'
      );

      this.morePublicPlans = publicPlans?.res?.filter(
        (item: any) => item.visibility === 'PUBLIC'
      );

    } catch (error) {
      console.log(error);
    }
    this.plans_loading = false;
  };

  loadPrivatePlans = async (plans_loading = true) => {
    try {
      this.plans_loading = plans_loading;

      let privatePlans = await this._user.getPersonPrivate({"person_code":this.person?.person?.code});

      debugger
      this.privatePlans = privatePlans?.res?.filter(
        (item: any) => item.visibility === 'PRIVATE'
      );

    } catch (error) {
      console.log(error);
    }
    this.plans_loading = false;
  };

  setDefaultPlan = async (planData: any) => {
    const plan = planData.plan;

    if (!plan || !this.code) {
      return;
    }

    try {
      const response = await this._user.updateDefaultPlan(this.code, plan);

      if (response && response.success) {
        alertifyjs.success('Plan agregado por defecto!');
        this.getCustomerPlans(this.code); // Refresh the plans list
      } else {
        alertifyjs.error('Failed to set plan as default');
      }
    } catch (error) {
      alertifyjs.error('Error setting default plan');
    }
  };

  selectPlan(item: any) {
    this.selectedPrivatePlan = item?._id;

    if (!this.selectedPrivatePlan) {
      console.warn('No plan selected');
      return;
    }
    this.updateCustomerPlans('add');
  }

  removePlan(plan: any) {
    this.selectedPrivatePlan = plan._id;

    if (this.selectedPrivatePlan && this.code) {
      this.updateCustomerPlans('remove');



    } else {
      console.warn('Plan ID or person code is missing');
    }
  }

  updateCustomerPlans = async (action: 'add' | 'remove') => {
    // Log the sessionUser object and id_ejecutive for debugging
    console.log('Session User:', this._auth.sessionUser);
    const id_ejecutive = this._auth.sessionUser?.uid;
    console.log('Executive ID (id_ejecutive):', id_ejecutive);

    if (this.selectedPrivatePlan && this.code) {
      try {
        // Log the plan and code for further debugging
        console.log('Selected Private Plan:', this.selectedPrivatePlan);
        console.log('Person Code:', this.code);
        console.log('Ejecutive id:', id_ejecutive)

        const response = await this._user.updateCustomerPlan(
          this.code,
          this.selectedPrivatePlan,
          action,
          id_ejecutive
        );

       delete this.customerPlans_obj[this.selectedPrivatePlan];



        // Log the response from the backend
        console.log('Response from updateCustomerPlan:', response);

        if (action === 'add') {
          alertifyjs.success('Plan agregado');
          this.offcanvasService.dismiss(this.getCustomerPlans);
        } else {
          alertifyjs.success('Plan eliminado');
        }

        this.getCustomerPlans(this.code);

      } catch (error) {
        console.error('Error updating customer plan:', error);
        alertifyjs.error(
          action === 'add'
            ? 'El plan ya está agregado'
            : 'Error eliminando el plan'
        );
      }
    } else {
      console.warn(
        'No se ha seleccionado ningun plan o el código de la persona no está definido'
      );
    }
  };

  isPlanAdded(planId: string): boolean {
    return this.plans.some((plan) => plan._id === planId);
  }

  details = async (plan: any) => {
    try {
      this.selectedPlan = this.selectedPlan === plan.code ? null : plan.code;
    } catch (error) {
      console.log(error);
    }
  };

  showAllPublicPlans = async (plan: any) => {
    try {
      this.showAllPublicPlansToggle = !this.showAllPublicPlansToggle;
    } catch (error) {
      console.log(error);
    }
  };
}
